import { render, staticRenderFns } from "./GroupsMobile.vue?vue&type=template&id=4a8fa237&scoped=true&"
import script from "./GroupsMobile.vue?vue&type=script&lang=js&"
export * from "./GroupsMobile.vue?vue&type=script&lang=js&"
import style0 from "./GroupsMobile.vue?vue&type=style&index=0&id=4a8fa237&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8fa237",
  null
  
)

export default component.exports